import {isPlatform} from "./platform"

/*
 * The document.execCommand() method's "cut" and "copy" commands can be used to replace the clipboard's current contents
 * with the selected material. These commands can be used without any special permission if you are using them in a
 * short-lived event handler for a user action (for example, a click handler).
 * https://developer.mozilla.org/en-US/docs/Mozilla/Add-ons/WebExtensions/Interact_with_the_clipboard
 *
 * ios solution:
 * https://stackoverflow.com/questions/34045777/copy-to-clipboard-using-javascript-in-ios
 */
export function clipboardCopy(text: string): Promise<void> {
  if (typeof navigator.clipboard?.write == 'function') {
      // https://developer.mozilla.org/en-US/docs/Web/API/ClipboardItem
      const blob = new Blob([text], { type: "text/plain" });
      const clipboardItemData = { "text/plain": blob };
      const clipboardItem = new ClipboardItem(clipboardItemData);
      return navigator.clipboard.write([clipboardItem])
          .catch(error => clipboardCopy(text))
  } else {
      let element = document.createElement('textarea');
      element.style.position = 'fixed';
      element.style.left     = '0';
      element.style.top      = '0';
      element.style.opacity  = '0';
      element.value = text;
      document.body.appendChild(element);
      if (isPlatform(window, 'ios')) {
          let range = document.createRange();
          element.contentEditable = 'true';
          element.readOnly = false;
          range.selectNodeContents(element);
          let selection = window.getSelection();
          if (selection) {
              selection.removeAllRanges();
              selection.addRange(range);
          }
          element.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.
      } else {
          element.focus();
          element.select();
      }
      document.execCommand('copy');
      document.body.removeChild(element);
      return Promise.resolve();
  }
}